import { render, staticRenderFns } from "./comPlaint.vue?vue&type=template&id=24d06e17&"
import script from "./comPlaint.vue?vue&type=script&lang=js&"
export * from "./comPlaint.vue?vue&type=script&lang=js&"
import style0 from "./comPlaint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports